import React, { useState, useEffect, useRef } from 'react';
import { TYPING_COMMANDS } from '../data/config';

const TypingGame = () => {
  const [currentCmd, setCurrentCmd] = useState('');
  const [userInput, setUserInput] = useState('');
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [gameStarted, setGameStarted] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const inputRef = useRef(null);

  const getRandomCommand = () => TYPING_COMMANDS[Math.floor(Math.random() * TYPING_COMMANDS.length)];

  const startGame = () => {
    setScore(0);
    setTimeLeft(30);
    setGameStarted(true);
    setGameOver(false);
    setCurrentCmd(getRandomCommand());
    setUserInput('');
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  useEffect(() => {
    if (!gameStarted || gameOver) return;
    if (timeLeft <= 0) {
      setGameOver(true);
      return;
    }
    const timer = setTimeout(() => setTimeLeft(t => t - 1), 1000);
    return () => clearTimeout(timer);
  }, [timeLeft, gameStarted, gameOver]);

  const handleInput = (e) => {
    const val = e.target.value;
    setUserInput(val);
    if (val === currentCmd) {
      setScore(s => s + currentCmd.length);
      setCurrentCmd(getRandomCommand());
      setUserInput('');
    }
  };

  const renderCommand = () => (
    currentCmd.split('').map((char, i) => (
      <span
        key={i}
        className={
          i < userInput.length
            ? userInput[i] === char ? 'correct' : 'incorrect'
            : ''
        }
      >
        {char}
      </span>
    ))
  );

  // Early return: Start screen
  if (!gameStarted) {
    return (
      <div className="typing-game">
        <div className="game-header">
          <span>TYPESPEED.exe</span>
          <span>Score: {score}</span>
        </div>
        <div className="game-overlay">
          <button onClick={startGame}>START TYPING</button>
          <p>Type commands as fast as you can!</p>
        </div>
      </div>
    );
  }

  // Early return: Game over screen
  if (gameOver) {
    return (
      <div className="typing-game">
        <div className="game-header">
          <span>TYPESPEED.exe</span>
          <span>Score: {score}</span>
        </div>
        <div className="game-overlay">
          <p className="game-over-text">TIME'S UP!</p>
          <p>Final Score: {score}</p>
          <p className="wpm-display">~{Math.round(score / 5)} WPM</p>
          <button onClick={startGame}>PLAY AGAIN</button>
        </div>
      </div>
    );
  }

  // Happy path: Active game
  return (
    <div className="typing-game">
      <div className="game-header">
        <span>TYPESPEED.exe</span>
        <span>Score: {score}</span>
      </div>
      <div className="typing-area">
        <div className="time-bar">
          <div className="time-fill" style={{ width: `${(timeLeft / 30) * 100}%` }} />
        </div>
        <div className="timer">{timeLeft}s</div>
        <div className="command-display">
          <span className="prompt">$</span>
          <span className="command-text">{renderCommand()}</span>
        </div>
        <input
          ref={inputRef}
          type="text"
          value={userInput}
          onChange={handleInput}
          className="typing-input"
          autoFocus
          spellCheck={false}
        />
      </div>
    </div>
  );
};

export default TypingGame;
